<template>
  <div
    v-if="isQueueModuleActive"
    class="queue-wrapper"
    data-testid="queue-wrapper"
  >
    <slot />
  </div>
</template>

<script>
import { useStore } from "vuex"
import { computed, watch } from "vue"
import { useRouter } from "vue-router"

export default {
  name: "QueueWrapper",
  setup() {
    const store = useStore()
    const router = useRouter()
    const isQueueModuleActive = computed(() => {
      return store.getters["queueSettings/isQueueModuleActive"]
    })

    watch(
      () => isQueueModuleActive.value,
      (newVal) => {
        if (!newVal) {
          const currentRole =
            store?.getters?.["authentication/getUserRole"] || ""
          if (currentRole === "student") {
            forceLogout()
          } else {
            router.push("/dashboard")
          }
        }
      }
    )

    const forceLogout = () => {
      store.dispatch("authentication/logOut")
      localStorage.removeItem("accessToken")
      localStorage.removeItem("devAccessToken")
      localStorage.removeItem("logoutTime")
      localStorage.removeItem("sessionEnd")
    }

    return {
      isQueueModuleActive
    }
  }
}
</script>

<style scoped></style>
